/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Source_Rtl_LabelInputs */



/**
* | output |
* | --- |
* | "Source is Right to Left" |
*
* @param {Translation_Import_Source_Rtl_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_source_rtl_label = /** @type {((inputs?: Translation_Import_Source_Rtl_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Source_Rtl_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La source est de droite à gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Quelle ist von rechts nach links geschrieben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La sorgente è da destra a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источник справа налево")
	if (locale === "es") return /** @type {LocalizedString} */ ("La fuente es de derecha a izquierda.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("来源方向为从右至左")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースは右から左へ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत दाएं से बाएं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A fonte é da direita para a esquerda.")
	return /** @type {LocalizedString} */ ("Source is Right to Left")
});